export default __webpack_public_path__ + "static/media/AUGDOM2025.ed23cb28.jpg";